import stripAnsi from 'strip-ansi'

export type TableOptions = { padding?: number }

/**
 * Add padding to each element on the table to left align each column
 *
 * Modify the original array in place
 */
export const table = (data: string[][], options?: TableOptions) => {
  // Find maximum number of columns
  let maxCols = 0
  data.forEach((row) => {
    if (row.length > maxCols) {
      maxCols = row.length
    }
  })

  // Max length of each column
  const maxLengths = new Array(maxCols).fill(0)

  for (const i of data.keys()) {
    for (const j of data[i].keys()) {
      if (stripAnsi(data[i][j]).length > maxLengths[j]) {
        maxLengths[j] = stripAnsi(data[i][j]).length
      }
    }
  }

  // Log each of the columns
  for (const row of data) {
    for (const [index, col] of row.entries()) {
      // Get the diff of colored string and non colored string
      const lengthDiff = col.length - stripAnsi(col).length

      // Assign correctly padded string
      row[index] = col.padEnd(
        maxLengths[index] + (options?.padding ?? 1) + lengthDiff,
      )
    }
  }
}
